var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "content",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 13.6167H5.83341C5.77786 13.6167 5.72786 13.6056 5.68341 13.5833C4.22786 13.1278 3.02786 12.225 2.08341 10.875C1.13897 9.52502 0.666748 8.03335 0.666748 6.40002V3.25002C0.666748 2.97224 0.747304 2.72224 0.908415 2.50002C1.06953 2.27779 1.27786 2.11668 1.53341 2.01668L5.53341 0.516683C5.68897 0.461127 5.84453 0.43335 6.00008 0.43335C6.15564 0.43335 6.31119 0.461127 6.46675 0.516683L10.4667 2.01668C10.7223 2.11668 10.9306 2.27779 11.0917 2.50002C11.2529 2.72224 11.3334 2.97224 11.3334 3.25002V6.40002C11.3334 8.03335 10.8612 9.52502 9.91675 10.875C8.9723 12.225 7.7723 13.1278 6.31675 13.5833C6.26119 13.6056 6.15564 13.6167 6.00008 13.6167Z",
    fill: "content"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.94aed159a59bbfa465229ece4f6dd68e.svg";
export { ForwardRef as ReactComponent };